import React from 'react';
import PropTypes from 'prop-types';

import '../styles/CloseMenu.css';

const CloseMenu = ({ menuItemName }) => (
    <div className="Close-menu-name">
      {menuItemName}
    </div>
)

CloseMenu.propTypes = {
    menuItemName: PropTypes.string.isRequired
}

export default CloseMenu;